import * as _ from "lodash";
import netlifyIdentity from "netlify-identity-widget";

const NEW_LINE = "\n";
export function generateWhatsappMsg({values, order}) {

    const clientPhoneNumber = (order.user.country.phone_code) + order.user.phoneNumber;
    const shippingCost = order.total >= order.user.minDelivery  ? "Gratis" : order.user.coin+''+order.user.deliveryCharge;
    let newMessage = "🛒 *Nuevo pedido via Kulko.App* 🛒" + NEW_LINE + NEW_LINE;
    newMessage += "*Pedido* #" + order.orderNumber + NEW_LINE + NEW_LINE;
    for (let [key, value] of Object.entries(order.orderProducts)) {
        newMessage+= ('*' + value.quantity + 'x ' + value.name + '* - $' + value.price);
        newMessage+=NEW_LINE;
    }
    newMessage+= NEW_LINE + "*Total:* $" + order.total + NEW_LINE;
    newMessage+= "*Forma de pago:* " + order.user.paymentInstructions + NEW_LINE;
    if(values.deliveryType === "programado"){
        newMessage+= "*Tipo de entrega:* Programado para " + values.date + " a las " + values.time + NEW_LINE + NEW_LINE;
    }
    else
        newMessage+= "*Tipo de entrega:* " + values.deliveryType + NEW_LINE + NEW_LINE;
    if (values.deliveryType === "pedirEnMesa")
        newMessage+= NEW_LINE + "*Número de mesa:* " + values.numeroMesa + NEW_LINE;
    newMessage+= "*Datos del cliente:* " + values.firstName + " " + values.lastName + NEW_LINE;
    newMessage+= "*Contacto:* +" + (values.country).match(/(\d+)/g) + values.phoneNumber + NEW_LINE + NEW_LINE;
    if(values.deliveryType === "delivery" || values.deliveryType === "programado"){
        newMessage+= "*Informacion de envio:* " + NEW_LINE + values.address1 + (values.address2 ? " / " + values.address2 : '') + NEW_LINE;
        newMessage+= "*Costo de envio:* " + shippingCost + NEW_LINE;

    }

    
    if (values.comment !== ""){
        newMessage+= NEW_LINE + "*Comentario:* " + values.comment + NEW_LINE;
    }
    let wspmsg = encodeURIComponent(newMessage);
    return "https://api.whatsapp.com/send?phone=" + clientPhoneNumber + "&text=" + wspmsg;
}


export function getCategoriesFromProducts(products) {
    let cat = _.map(products, p=>{return p.category});
    return _.uniqWith(cat,_.isEqual);
}

export function useNull() {
    return null;
}

export async function getHeaders() {
    const user = netlifyIdentity.currentUser();
    await user.jwt();
    let token = user.token.access_token;
    return {
        'Content-Type': 'application/json',
        'X-AUTH-TOKEN': token
    }
}

export function get_browser() {
    var ua=navigator.userAgent,tem,M=ua.match(/(opera|chrome|safari|firefox|msie|trident(?=\/))\/?\s*(\d+)/i) || [];
    if(/trident/i.test(M[1])){
        tem=/\brv[ :]+(\d+)/g.exec(ua) || [];
        return {name:'IE',version:(tem[1]||'')};
    }
    if(M[1]==='Chrome'){
        tem=ua.match(/\bOPR|Edge\/(\d+)/)
        if(tem!=null)   {return {name:'Opera', version:tem[1]};}
    }
    M=M[2]? [M[1], M[2]]: [navigator.appName, navigator.appVersion, '-?'];
    if((tem=ua.match(/version\/(\d+)/i))!=null) {M.splice(1,1,tem[1]);}
    return {
        name: M[0],
        version: M[1]
    };
}